import React from 'react';
import { icons } from 'seal-ui-components';
import ScoreCardAnalyticValue from './components/ScoreCardAnalyticValue';
import { AnalyticDiv, ErrorText } from './ScoreCardAnalytic.style';

const ScoreCardAnalytic = ({
    filteredAnalytic,
    highlightObj,
    navigating,
    navigatingTo,
    navigationFailedFlag,
    scorecardIndex,
    extractionIndex,
    filteredAnalytics,
    curExtIndex,
    setCurExtIndex,
    setCurExtNumber,
    policyHighlightHandler,
    riskLevel,
    extractionCount,
    ruleId,
    rulePosition
}) => {
    const attributeValue = filteredAnalytic.attributes[0].value;
    const uniqueIndex = `${attributeValue}-${filteredAnalytic.endOffset}`;
    const isNavigatingToPolicyName = navigatingTo.name === attributeValue;
    const isNavigatingToIndex = navigatingTo.index === uniqueIndex;
    return (
        <div>
            <AnalyticDiv>
                {navigating && isNavigatingToIndex && <icons.LoadingSmallIcon />}
                {navigationFailedFlag &&
                    isNavigatingToIndex && <ErrorText>Couldn&#39;t find this label</ErrorText>}
                <ScoreCardAnalyticValue
                    key={filteredAnalytic.endOffset}
                    index={filteredAnalytic.endOffset}
                    value={filteredAnalytic.value}
                    name={attributeValue}
                    highlighted={highlightObj.highlightedLocationIdx === uniqueIndex}
                    navFailed={
                        navigationFailedFlag && isNavigatingToPolicyName && isNavigatingToIndex
                    }
                    scorecardIndex={scorecardIndex}
                    extractionIndex={extractionIndex}
                    filteredAnalytics={filteredAnalytics}
                    curExtIndex={curExtIndex}
                    setCurExtIndex={setCurExtIndex}
                    setCurExtNumber={setCurExtNumber}
                    policyHighlightHandler={policyHighlightHandler}
                    riskLevel={riskLevel}
                    extractionCount={extractionCount}
                    ruleId={ruleId}
                    rulePosition={rulePosition}
                />
            </AnalyticDiv>
        </div>
    );
};

export default React.memo(ScoreCardAnalytic, (prevProps, nextProps) => {
    if (JSON.stringify(prevProps) !== JSON.stringify(nextProps)) return false;

    return true;
});
